module.exports = {
	'standardMonthlyPricePerMonth':	'$8.99',
	'standardMonthlyPricePerYear':	'$107.88',
	'standardYearlyPricePerMonth':	'$5.99',
	'standardYearlyPricePerYear':	'$71.88',
	'percentageSavingStandardYearly': '33%',
}
    